/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PersonDropdown_persons$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UpdateContactModal_company$ref: FragmentReference;
declare export opaque type UpdateContactModal_company$fragmentType: UpdateContactModal_company$ref;
export type UpdateContactModal_company = {|
  +id: string,
  +oktaEnabled: ?boolean,
  +oneloginEnabled: ?boolean,
  +AADEnabled: ?boolean,
  +contactPersons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +contactType: ?string,
        +person: ?{|
          +id: string
        |},
      |}
    |}>
  |},
  +allPersons: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +fullName: ?string,
        +email: ?string,
        +jobTitle: ?string,
        +phone: ?string,
        +profilePictureId: ?string,
        +role: ?{|
          +name: ?string
        |},
        +permissions: ?$ReadOnlyArray<?string>,
      |},
      +$fragmentRefs: PersonDropdown_persons$ref,
    |}>
  |},
  +$refType: UpdateContactModal_company$ref,
|};
export type UpdateContactModal_company$data = UpdateContactModal_company;
export type UpdateContactModal_company$key = {
  +$data?: UpdateContactModal_company$data,
  +$fragmentRefs: UpdateContactModal_company$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "contactPersons"
        ]
      }
    ]
  },
  "name": "UpdateContactModal_company",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oktaEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oneloginEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "AADEnabled",
      "storageKey": null
    },
    {
      "alias": "contactPersons",
      "args": null,
      "concreteType": "CompanyContactTypeConnection",
      "kind": "LinkedField",
      "name": "__Company_contactPersons_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CompanyContactTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CompanyContact",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "contactType",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Person",
                  "kind": "LinkedField",
                  "name": "person",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "excludeClientUsers",
          "value": true
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 10000
        },
        {
          "kind": "Literal",
          "name": "onlyActive",
          "value": true
        }
      ],
      "concreteType": "PersonTypeConnection",
      "kind": "LinkedField",
      "name": "allPersons",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PersonTypeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Person",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fullName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "jobTitle",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "phone",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "role",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "permissions",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PersonDropdown_persons"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "allPersons(excludeClientUsers:true,first:10000,onlyActive:true)"
    }
  ],
  "type": "Company"
};
})();
// prettier-ignore
(node/*: any*/).hash = '0d66a27ebc193d5eee2305a2bc3c86bb';

module.exports = node;
